<template>
  <div class="hijack">
    <button v-if="!hijacked" class="btn-regular primary loading" @click.stop="startHijack" :disabled="submitIsLoading">
      Login As {{email}}
      <loading-secondary v-if="submitIsLoading" slot="loading" />
    </button>
    <button v-else class="btn-regular primary loading" @click.stop="releaseHijack" :disabled="submitIsLoading">
      Release {{this.profile.email}}
      <loading-secondary v-if="submitIsLoading" slot="loading" />
    </button>
  </div>
</template>

<script>
import LoadingPrimary from '@/components/Loading/Primary'
import LoadingSecondary from '@/components/Loading/Secondary'
import api from '@/api'
import { apiV2 } from '@/api/urls'
import { mapGetters, mapActions, mapMutations } from 'vuex'
import { errorMessage } from '@/lib/error'

export default {
  name: 'adx-hijack-tools',
  components: {
    'loading-primary': LoadingPrimary,
    'loading-secondary': LoadingSecondary
  },
  props: {

  },
  data() {
    return {
      email: false,
      submitIsLoading: false
    }
  },
  computed: {
    ...mapGetters({
      token: 'token',
      hijacked: 'hijacked',
      profile: 'profile'
    })
  },
  watch: {

  },
  beforeCreate() {

  },
  created() {

  },
  beforeMount() {
    const { email } = this.$route.params
    if (email) {
      this.email = email
    } else {
      this.$router.push({name: '404'})
    }
  },
  mounted() {

  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {
    startHijack () {
      (async () => {
        this.submitIsLoading = true
        const body = {
          email: this.email
        }
        const response = await api.post(apiV2.hijack, body, { needToken: true });
        if (response.status === 200) {

          const hijackedAccount = response.data
          await this.$store.dispatch(`startHijack`, response.data)
          this.$router.push({name: 'home'})
          window.location.reload()
        } else {
          this.$notify({
            group: 'saved',
            title: `error ${response.status}`,
            text: `${errorMessage[response.status].message}`,
            type: 'danger'
          })
        }
        this.submitIsLoading = false
      })();
    },
    releaseHijack () {
      (async () => {
        this.submitIsLoading = true
        const body = {}
        const response = await api.post(apiV2.releaseHijack, body, { needToken: true })
        console.log(`resp: `, response)
        if (response.status === 200) {
          await this.$store.dispatch(`releaseHijack`)
          this.$router.push({name: 'home'})
          window.location.reload()
        } else {
          this.$notify({
            group: 'saved',
            title: `error ${response.status}`,
            text: `${errorMessage[response.status].message}`,
            type: 'danger'
          })
        }
        this.submitIsLoading = false
      })();
    }
  }
}
</script>

<style lang='scss' scoped>
// @import '~@/styles/variables';
// @import '~@/styles/mixins';
.loading {
  display: flex;
  align-items: center;

  div {
    margin-left: 4px;
  }
}
</style>